import { dateUIToBackend } from 'modules/core/lib/dates'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'
import type { Change, CustomFieldsWithValues } from 'modules/employees/pages/EditInBulk/types'

const mapBulkFormToChange = (
  form: BulkEditForm,
  customFieldsWithValues?: CustomFieldsWithValues
): Change => {
  const change: Change = {}

  if (form.get('manager_id').isDirty) change.manager_id = parseInt(form.get('manager_id').value)

  if (form.get('location_id').isDirty) change.location_id = parseInt(form.get('location_id').value)

  if (form.get('timeoff_manager_id').isDirty)
    change.timeoff_manager_id = parseInt(form.get('timeoff_manager_id').value)

  if (form.get('timeoff_policy_id').isDirty)
    change.timeoff_policy_id = parseInt(form.get('timeoff_policy_id').value)

  if (form.get('regular_access_starts_on').isDirty)
    change.regular_access_starts_on = dateUIToBackend(form.get('regular_access_starts_on').value)

  if (form.get('teams_ids').isDirty)
    change.teams_ids = form.get('teams_ids').value.map((teamId: number) => teamId)

  if (form.get('permission_group_id').isDirty)
    change.permission_group_id = parseInt(form.get('permission_group_id').value)

  if (form.get('employee_group_id').isDirty || form.get('legal_entity_id').isDirty) {
    change.employee_group_id = parseInt(form.get('employee_group_id').value)
    change.legal_entity_id = parseInt(form.get('legal_entity_id').value)
  }

  if (customFieldsWithValues) {
    Object.entries(customFieldsWithValues).forEach(([customFieldId, customFieldValue]) => {
      change[customFieldId] = customFieldValue ?? form.get(customFieldId.toString()).value
    })
  }

  return change
}

export default mapBulkFormToChange
